import { useParams } from 'react-router-dom';
import { useAuth } from '@/app/providers';
import { DirectMessageScreen } from './components/DirectMessageScreen';
import { useDirectPeer } from './hooks/useDirectMessages';

export function DirectMessagePage() {
  const { conversationId } = useParams<{ conversationId: string }>();
  const { user } = useAuth();
  const { data: peer, isLoading } = useDirectPeer(conversationId, user?.id);

  return <DirectMessageScreen peer={peer ?? null} conversationId={conversationId} loading={isLoading} />;
}
